import { IRowNode } from 'ag-grid-community';
import { AbstractFeatureChildUIModel, AbstractFeatureUIModel } from '../../models';
import { FeatureListViewData } from './abstract-feature-list-view.service.model';

/**
 * Returns the `$path` property for the given row node.
 * Works also with "grouped" rows (like in Integrations).
 */
export function getFeatureListViewRowId(
  node: IRowNode,
): AbstractFeatureUIModel['$path'] | AbstractFeatureChildUIModel['$path'] | null {
  const data = node.data as FeatureListViewData<AbstractFeatureUIModel, AbstractFeatureChildUIModel> | undefined;
  const $path = data?.child_$path || node.aggData?.id || node.key || data?.$path;
  return $path || null;
}
